module.exports = __webpack_public_path__ + "static/media/icon-css.20fdca6c.svg";